import React from 'react';
import trans from '../translations.json';
import OverviewTables from '../components/overview/overviewTables';
import dict from '../dictionary';
import ReducedData from '../reducedData.json';
import OnThisPage from './onThisPage/onThisPage';

var covidData = ReducedData.covidData;
const latest = covidData[covidData.length - 1];
const previous = covidData[covidData.length - 2];
// const latest = covidData.slice(-1).pop();
// const previous = covidData.slice(-2, -1).pop();
//const totalSince = moment(covidData[0][dic.reportedDate]);
const totalSince = 'Jan 15, 2020';

const Header = (props) => {
  const stats = {
    cumm: [
      {
        label: trans.viewModes.total[props.lang],
        value: latest[dict.totaCases],
        difference: latest[dict.totaCases] - previous[dict.totaCases],
      },
      {
        label: trans.viewModes.resolved[props.lang],
        value: latest[dict.resolved],
        difference: latest[dict.resolved] - previous[dict.resolved],
      },
      {
        label: trans.viewModes.deaths[props.lang],
        value: latest[dict.deaths],
        difference: latest[dict.deaths] - previous[dict.deaths],
      },
    ],
    curr: [
      {
        label: trans.hospital.hospitalized[props.lang],
        value: latest[dict.patientHospitalizedCOVID19],
        difference:
          latest[dict.patientHospitalizedCOVID19] -
          previous[dict.patientHospitalizedCOVID19],
      },
      {
        label: trans.overview.icuAbbr[props.lang],
        value: latest[dict.patientsICUwCOVID19],
        difference:
          latest[dict.patientsICUwCOVID19] -
          previous[dict.patientsICUwCOVID19],
      },
      {
        label: trans.hospital.ventilator[props.lang],
        value: latest[dict.patientsICUventilatorwCOVID19],
        difference:
          latest[dict.patientsICUventilatorwCOVID19] -
          previous[dict.patientsICUventilatorwCOVID19],
      },
    ],
  };

  return (
    <div>
      <OverviewTables
        stats={stats}
        lang={props.lang}
        lastUpdated={props.lastUpdated}
        totalSince={totalSince}
        withLegend={true}
        withReproduction={true}
        labels={[trans.overview.inHospital[props.lang]]}
        descs={[trans.overview.currently[props.lang]]}
      />
      <hr aria-hidden="true" className="ontario-thick"></hr>
      <OnThisPage
        lang={props.lang}
        sections={[
          {
            href: '#case_numbers_and_spread',
            category: 'otp',
            text: 'byNumbers',
          },
          {
            href: '#testing',
            category: 'otp',
            text: 'testing',
          },
          {
            href: '#hospitalizations',
            category: 'otp',
            text: 'hospitalizations',
          },
          {
            href: '#where_numbers',
            category: 'otp',
            text: 'numberscomefrom',
          },
        ]}
      />
    </div>
  );
};

export default Header;
